    <!--<div *ngIf="history">-->
    <!--<div class="map" #map></div>-->
    <!--</div>-->


    <div id="map" class="map"></div>
    <!-- <div>
      <mgl-map
        [style]="'mapbox://styles/mapbox/streets-v9'"
        [zoom]="[9]"
        [center]="[-74.5, 40]"
      >
      </mgl-map>
    </div> -->

    <!--<agm-map style="height: 800px"   [zoom]="zoom" [fullscreenControl]="true" [latitude]="lat" [longitude]="lng" >-->
    <!--<div *ngIf="history;else liveLocationView">-->

    <!--<div *ngFor="let point of snappedPoints;let i=index">-->
    <!--<agm-polyline [strokeColor]="'#2196f3'">-->
    <!--<ng-container *ngFor="let polyline of point['snappedPoints'];let j=index">-->
    <!--<agm-polyline-point [latitude]="polyline.location.latitude"-->
    <!--[longitude]="polyline.location.longitude">-->
    <!--</agm-polyline-point>-->

      <!--&lt;!&ndash;<agm-marker *ngIf="(i==0 &&j==0)" [iconUrl]="'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|FE7569'"&ndash;&gt;-->
      <!--&lt;!&ndash;[longitude]="polyline.location.longitude" [latitude]="polyline.location.latitude">&ndash;&gt;-->

      <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->
    <!--</ng-container>-->

      <!--<ng-container>-->
        <!--<div *ngFor="let visit of repVisits;let i=index">-->
          <!--<agm-marker [title]="'Visit'+(i+1)" [longitude]="visit.start_geo_tag.lng" [latitude]="visit.start_geo_tag.lat">-->
            <!--<agm-info-window [disableAutoPan]="true">-->
              <!--<strong>{{visit.client_name}} </strong>-->
              <!--<br>Time: {{visit.start_time | date:'shortTime' }}-->
              <!--<br> {{visit.time | date }}-->

            <!--</agm-info-window>-->
          <!--</agm-marker>-->
        <!--</div>-->
        <!--&lt;!&ndash;<div *ngFor="let visit of repVisits">&ndash;&gt;-->
          <!--&lt;!&ndash;<agm-marker *ngIf="visit.client_geo_location" [iconUrl]="'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|0483c7'" [longitude]="visit.client_geo_location.lng" [latitude]="visit.client_geo_location.lat">&ndash;&gt;-->

          <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</ng-container>-->
      <!--&lt;!&ndash;<ng-container>&ndash;&gt;-->
        <!--&lt;!&ndash;<div *ngIf="visitMarker">&ndash;&gt;-->
          <!--&lt;!&ndash;<agm-marker [animation]="userLocationMarkerAnimation" [longitude]="visitSelectedLng" [latitude]="visitSelectedLat">&ndash;&gt;-->
          <!--&lt;!&ndash;aaa&ndash;&gt;-->
          <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</ng-container>&ndash;&gt;-->

    <!--</agm-polyline>-->





    <!--</div>-->

    <!--</div>-->
    <!--<ng-template #liveLocationView>-->

    <!--<div   *ngFor="let m   of repLiveLocation; let visitSeq = index">-->

    <!--<agm-overlay-->
      <!--*ngIf="!hideRep.includes(m._id) && m._id"-->
    <!--[latitude]  = "m.lat"-->
    <!--[longitude] = "m.lng"-->
    <!--[visible]="!history"-->
    <!--&gt;-->

<!--<div>-->


    <!--<div class="">-->
    <!--<div class="dot"></div>-->
    <!--<div class="pulse"></div>-->
    <!--</div>-->
    <!--<agm-info-window [disableAutoPan]="true">-->
    <!--<strong>{{m.user_name}} </strong>-->
    <!--<br>Last Seen: {{m.time | date:'shortTime' }}-->
    <!--<br> {{m.time | date }}-->

    <!--</agm-info-window>-->
<!--</div>-->
    <!--</agm-overlay>-->

    <!--</div>-->
    <!--</ng-template>-->


    <!--</agm-map>-->



    <!--<div class="panel panel-map panel-warning" *ngIf="history">-->
        <!--<div class="panel-heading col-md-6" style="border-radius: 8%">-->
          <!--<h3 class="panel-title">Live Location</h3>-->


          <!--&lt;!&ndash;<span class="pull-right clickable"><i class="fa fa-arrow-left"></i></span>&ndash;&gt;-->
        <!--</div>-->
        <!--<div class="pull-right">-->
          <!--<img src="../../../assets/images/logo-orange.svg" style="width: 120px;margin-top: 4px">-->

      <!--</div>-->







    <!--<div *ngIf="history">-->
      <!--<div class="map" #map></div>-->
    <!--</div>-->

    <!--<agm-map  (mapReady)="mapReady($event)"  [fullscreenControl]="true" [latitude]="lat" [longitude]="lng" >-->
      <!--<div style="background: white">-->
        <!--<div id="Settings1"  class="switch toggleswitch toggle-button controls button" style="    margin: 8px;-->
    <!--padding: 8px;-->
    <!--z-index: 0;-->
    <!--border-radius: 8px;-->
    <!--position: absolute;-->
    <!--left: 0px;-->
    <!--top: 0px;-->
    <!--background: white;">-->
          <!--<span for="toggle-checked1" class="pull-left"><br> Histroy</span>-->
          <!--<input id="toggle-checked1" [checked]="!history" (click)="changeLiveView()"  class="ch-toggle ch-toggle-green"-->
                 <!--type="checkbox">-->
          <!--<label for="toggle-checked1"></label>-->
        <!--</div>-->
      <!--</div>-->
<!--<div *ngIf="history;else liveLocationView">-->



  <!--<div *ngFor="let point of snappedPoints;let i=index">-->
    <!--<agm-polyline [strokeColor]="'#2196f3'">-->
      <!--<ng-container *ngFor="let polyline of point['snappedPoints']">-->
        <!--<agm-polyline-point [latitude]="polyline.location.latitude"-->
                            <!--[longitude]="polyline.location.longitude">-->
        <!--</agm-polyline-point>-->
      <!--</ng-container>-->
    <!--</agm-polyline>-->

  <!--</div>-->



<!--</div>-->
      <!--<ng-template #liveLocationView>-->

        <!--<div>-->
          <!--<agm-overlay-->
            <!--*ngFor="let m   of waypoints; let visitSeq = index"-->
            <!--[latitude]  = "m.lat"-->
            <!--[longitude] = "m.lng"-->
            <!--[visible]="!history"-->
              <!--&gt;-->




            <!--<div class="">-->
              <!--<div class="dot"></div>-->
              <!--<div class="pulse"></div>-->
            <!--</div>-->
            <!--<agm-info-window [disableAutoPan]="true">-->
              <!--<strong>{{m.user_name}} </strong>-->
              <!--<br>Last Seen: {{m.time | date:'shortTime' }}-->
              <!--<br> {{m.time | date }}-->

            <!--</agm-info-window>-->

          <!--</agm-overlay>-->

        <!--</div>-->
      <!--</ng-template>-->


    <!--</agm-map>-->

    <!--<div class="panel  panel-warning" style="left: 50% !important;">-->

      <!--<div *ngFor="let i of [1,2,3];let index=index">-->

        <!--<div class="cardx" style="left: 35%">-->
          <!--<span class="badge-activity">Photo</span>-->
          <!--<div class="text-center">-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>Total</h4>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>5</h4>-->
              <!--</div>-->
            <!--</div>-->

            <!--&lt;!&ndash;<div class="img">&ndash;&gt;-->
              <!--&lt;!&ndash;<img src="https://www.planwallpaper.com/static/images/cool-wallpaper-5_G6Qe1wU.jpg">&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

          <!--</div>-->
        <!--</div>-->
        <!--<div class="cardx " style="left: 50% !important;" >-->
          <!--<span class="badge-activity" style="background: yellow;color:black">Note</span>-->
          <!--<div class="text-center">-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>Total</h4>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>10</h4>-->
              <!--</div>-->
            <!--</div>-->

            <!--&lt;!&ndash;<div class="img">&ndash;&gt;-->
              <!--&lt;!&ndash;<img src="https://www.planwallpaper.com/static/images/cool-wallpaper-5_G6Qe1wU.jpg">&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

          <!--</div>-->
        <!--</div>-->
        <!--<div class="cardx" style="left: 65% !important;">-->
          <!--<span class="badge-activity" style="background: green">Audit</span>-->
          <!--<div class="text-center">-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>Total</h4>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="row">-->
              <!--<div class="col-md-12">-->
                <!--<h4>12</h4>-->
              <!--</div>-->
            <!--</div>-->

            <!--&lt;!&ndash;<div class="img">&ndash;&gt;-->
              <!--&lt;!&ndash;<img src="https://www.planwallpaper.com/static/images/cool-wallpaper-5_G6Qe1wU.jpg">&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

          <!--</div>-->
        <!--</div>-->


      <!--</div>-->

      <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->


      <!--&lt;!&ndash;<div *ngFor="let i of [1,2,3];let index=index">&ndash;&gt;-->

     <!--&lt;!&ndash;<div class="col-md-3">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="cardx">&ndash;&gt;-->
          <!--&lt;!&ndash;<span class="badge-activity">Photo</span>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="text-center">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
                <!--&lt;!&ndash;<h4>Total</h4>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
                <!--&lt;!&ndash;<h4>5</h4>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

            <!--&lt;!&ndash;&lt;!&ndash;<div class="img">&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;<img src="https://www.planwallpaper.com/static/images/cool-wallpaper-5_G6Qe1wU.jpg">&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->

          <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
     <!--&lt;!&ndash;</div>&ndash;&gt;-->



      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->


    <!--</div>-->





<!--<app-menu></app-menu>-->
<!--<div class="page-content-wrapper">-->
  <!--<div class="container-fluid page-content">-->
    <!--<div class="row defult-margin">-->
      <!--<div class="col-md-12 ">-->
        <!--<div class="row">-->
          <!--<div class="col-md-12">-->
            <!--<app-filters [withTime]="false" (FilteredQuery)="receiveQuery($event)"></app-filters>-->
          <!--</div>-->
        <!--</div>-->

        <!--<div class="row  fadeInUp">-->


          <!--<div class="col-lg-12  fadeInUp" >-->
            <!--<div class="col-content content-overflow">-->
              <!--<h5 class="title">Route Report</h5>-->
              <!--&lt;!&ndash;&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="map" #map></div>&ndash;&gt;-->

              <!--<agm-map  [fullscreenControl]="true" [latitude]="lat" [longitude]="lng">-->
                <!--<agm-direction-->
                  <!--[optimizeWaypoints]="true"-->
                  <!--[travelMode]="'DRIVING'"-->
                  <!--[origin]="origin"-->
                  <!--[destination]="destination"-->
                  <!--[renderOptions]="renderOptions"-->
                  <!--[markerOptions]="markerOptions"-->
                  <!--[waypoints]="waypoints"-->
                <!--&gt;-->
                <!--</agm-direction>-->



                <!--<div *ngFor="let m   of waypoints; let visitSeq = index">-->


                <!--<agm-marker [iconUrl]="'https://demo.gpswox.com/assets/images/history2.png'"  [longitude]="m.location.lng" [latitude]="m.location.lat">-->

                <!--</agm-marker>-->
                <!--</div>-->
              <!--</agm-map>-->



              <!--<button class="btn-primary btn" (click)="more()">more</button>-->

              <!--<hr>-->


              <!--&lt;!&ndash;<agm-map [latitude]="lat" [fullscreenControl]="true" [longitude]="lng" [zoom]="14">&ndash;&gt;-->
              <!--&lt;!&ndash;<div *ngFor="let m   of live; let visitSeq = index">&ndash;&gt;-->


              <!--&lt;!&ndash;<agm-marker *ngIf="m.active_visit" [label]="''+(visitSeq+1)+''" [longitude]="m.lng"&ndash;&gt;-->
              <!--&lt;!&ndash;[latitude]="m.lat">&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->

              <!--<agm-info-window [disableAutoPan]="true">-->
              <!--<strong>{{m.client_name}} </strong>-->
              <!--<br> {{m.time | date:'shortTime' }}-->
              <!--<br> {{m.time | date }}-->

              <!--</agm-info-window>-->

              <!--</div>-->
              <!--</agm-map>-->


              <!--&lt;!&ndash;<agm-map [latitude]="live[0].lat" [fullscreenControl]="true" [longitude]="live[0].lng" [zoom]="14">&ndash;&gt;-->
              <!--&lt;!&ndash;<div >&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-marker [label]="'start'" [longitude]="live[0].lng"&ndash;&gt;-->
              <!--&lt;!&ndash;[latitude]="live[0].lat">&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-info-window [disableAutoPan]="true">&ndash;&gt;-->
              <!--&lt;!&ndash;<strong>{{live[0].user_name}} </strong>&ndash;&gt;-->
              <!--&lt;!&ndash;<br> {{live[0].time | date:'shortTime' }}&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-info-window>&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-polyline [strokeColor]="'#2196f3'">&ndash;&gt;-->
              <!--&lt;!&ndash;<ng-container *ngFor="let polyline of live">&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-polyline-point [latitude]="polyline.lat"&ndash;&gt;-->
              <!--&lt;!&ndash;[longitude]="polyline.lng">&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-polyline-point>&ndash;&gt;-->
              <!--&lt;!&ndash;</ng-container>&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-polyline>&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-marker [label]="'start'" [longitude]="live[live.length-1].lng"&ndash;&gt;-->
              <!--&lt;!&ndash;[latitude]="live[live.length-1].lat">&ndash;&gt;-->
              <!--&lt;!&ndash;<agm-info-window [disableAutoPan]="true">&ndash;&gt;-->
              <!--&lt;!&ndash;<strong>{{live[live.length-1].user_name}} </strong>&ndash;&gt;-->
              <!--&lt;!&ndash;<br> {{live[live.length-1].time | date:'shortTime' }}&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-info-window>&ndash;&gt;-->
              <!--&lt;!&ndash;</agm-marker>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->

              <!--&lt;!&ndash;</agm-map>&ndash;&gt;-->
      <!---->
            <!--</div>-->

            <!--<div class="col-content content-overflow">-->
              <!--<div class="col-md-12 "  >-->
                <!--<table class="table">-->
                  <!--<tr>-->
                    <!--<th>Count</th>-->
                    <!--<th>Time</th>-->
                    <!--<th>Rep</th>-->
                    <!--<th>Lat</th>-->
                    <!--<th>Lng</th>-->
                  <!--</tr>-->
                  <!--<tr *ngFor="let l of live; let i=index">-->
                    <!--<td>{{i}}</td>-->
                    <!--<td>{{l.time|date:'short'}}</td>-->
                    <!--<td>{{l.user_name}}</td>-->
                    <!--<td>{{l.lat}}</td>-->
                    <!--<td>{{l.lng}}</td>-->
                  <!--</tr>-->

                <!--</table>-->
              <!--</div>-->
            <!--</div>-->



          <!--</div>-->

        <!--</div>-->
      <!--</div>-->
    <!--</div>-->

  <!--</div>-->
<!--</div>-->





<!--&lt;!&ndash;<app-menu></app-menu>&ndash;&gt;-->

<!--&lt;!&ndash;<div class="page-content-wrapper">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="container-fluid page-content">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row defult-margin">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12 ">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row  fadeInUp">&ndash;&gt;-->


<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12  fadeInUp">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-content">&ndash;&gt;-->
<!--&lt;!&ndash;<h5 class="title">Live Location</h5>&ndash;&gt;-->


<!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
<!--&lt;!&ndash;<app-filters (FilteredQuery)="receiveQuery($event)"></app-filters>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row">&ndash;&gt;-->

<!--&lt;!&ndash;<div class="col-md-2 col-xs-2 col-lg-1">&ndash;&gt;-->

<!--&lt;!&ndash;<select id="rows" class="form-control input-number-rows" ([ngModel])="pageSize" #rowLength&ndash;&gt;-->
<!--&lt;!&ndash;(change)="viewCount(rowLength.value)">&ndash;&gt;-->
<!--&lt;!&ndash;<option value="10">10</option>&ndash;&gt;-->
<!--&lt;!&ndash;<option value="25" selected>25</option>&ndash;&gt;-->
<!--&lt;!&ndash;<option value="50">50</option>&ndash;&gt;-->
<!--&lt;!&ndash;<option value="100">100</option>&ndash;&gt;-->
<!--&lt;!&ndash;</select>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-3 col-xs-2 col-lg-2">&ndash;&gt;-->
<!--&lt;!&ndash;<button class="btn btn-default btn-sm dropdown-toggle drop-button" type="button"&ndash;&gt;-->
<!--&lt;!&ndash;(click)="export()">&ndash;&gt;-->
<!--&lt;!&ndash;Export to Excel&ndash;&gt;-->
<!--&lt;!&ndash;</button>&ndash;&gt;-->


<!--&lt;!&ndash;</div>&ndash;&gt;-->


<!--&lt;!&ndash;<div class="col-md-4 pull-right">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="input-group input-group-sm mr-sm-2 mb-3 mb-sm-0">&ndash;&gt;-->
<!--&lt;!&ndash;<span class="input-group-addon">&ndash;&gt;-->
<!--&lt;!&ndash;<i class="fa fa-search"></i>&ndash;&gt;-->
<!--&lt;!&ndash;</span>&ndash;&gt;-->
<!--&lt;!&ndash;<input #search class="form-control" (keyup)="($event)" placeholder="Search">&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<div *ngIf="loading" style="text-align: center">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<img class="overlay" src="../../../assets/images/loading.gif">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;<div style="overflow: scroll">&ndash;&gt;-->


<!--&lt;!&ndash;<span>xx  {{data.length}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;<table id="tableV" class="table showReviewMark ">&ndash;&gt;-->
<!--&lt;!&ndash;<thead>&ndash;&gt;-->
<!--&lt;!&ndash;<tr>&ndash;&gt;-->
<!--&lt;!&ndash;<th class="table-header" [ngClass]="key=='time'?typeOfSort=='asc'?'asc-sort':'desc-sort':''"&ndash;&gt;-->
<!--&lt;!&ndash;(click)="sort('time')">&ndash;&gt;-->
<!--&lt;!&ndash;<div>Date</div>&ndash;&gt;-->
<!--&lt;!&ndash;</th>&ndash;&gt;-->
<!--&lt;!&ndash;<th #rep class="table-header"&ndash;&gt;-->
<!--&lt;!&ndash;[ngClass]="key=='user_name'?typeOfSort=='asc'?'asc-sort':'desc-sort':''"&ndash;&gt;-->
<!--&lt;!&ndash;(click)="sort('user_name')">&ndash;&gt;-->
<!--&lt;!&ndash;<div>Representative</div>&ndash;&gt;-->
<!--&lt;!&ndash;</th>&ndash;&gt;-->
<!--&lt;!&ndash;<th class="table-header"&ndash;&gt;-->
<!--&lt;!&ndash;[ngClass]="key=='client_name'?typeOfSort=='asc'?'asc-sort':'desc-sort':''"&ndash;&gt;-->
<!--&lt;!&ndash;(click)="sort('client_name')">&ndash;&gt;-->
<!--&lt;!&ndash;<div>Client Name</div>&ndash;&gt;-->
<!--&lt;!&ndash;</th>&ndash;&gt;-->

<!--&lt;!&ndash;<th class="table-header">&ndash;&gt;-->
<!--&lt;!&ndash;<div>Out of Geofencing</div>&ndash;&gt;-->
<!--&lt;!&ndash;</th>&ndash;&gt;-->


<!--&lt;!&ndash;</tr>&ndash;&gt;-->
<!--&lt;!&ndash;</thead>&ndash;&gt;-->
<!--&lt;!&ndash;<tbody>&ndash;&gt;-->

<!--&lt;!&ndash;<tr style="border-bottom: 1px solid #c7c7c7 !important"&ndash;&gt;-->
<!--&lt;!&ndash;*ngFor="let n of dataPaging; let i=index">&ndash;&gt;-->
<!--&lt;!&ndash;<td class="table-cell-long-text">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="">{{n.time}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;</td>&ndash;&gt;-->
<!--&lt;!&ndash;<td class="table-cell-long-text">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="">{{n.rep_name}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;</td>&ndash;&gt;-->
<!--&lt;!&ndash;<td class="table-cell-long-text">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="">{{n.client_name}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;</td>&ndash;&gt;-->
<!--&lt;!&ndash;<td class="table-cell-long-text">&ndash;&gt;-->
<!--&lt;!&ndash;<div class=""><a href="#locations" (click)="mapLocationView(n)" data-toggle="modal"&ndash;&gt;-->
<!--&lt;!&ndash;data-target="#locations"&ndash;&gt;-->
<!--&lt;!&ndash;&gt;{{n.locations.length}}</a></div>&ndash;&gt;-->
<!--&lt;!&ndash;</td>&ndash;&gt;-->


<!--&lt;!&ndash;&lt;!&ndash;<i *ngIf="!n.seen" class="fa fa-check   review" (click)="selectActivity(n.seen,n._id)"></i>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<i *ngIf="n.seen" class="fa fa-times   unreview" (click)="selectActivity(n.seen,n._id)"></i>&ndash;&gt;&ndash;&gt;-->


<!--&lt;!&ndash;</tr>&ndash;&gt;-->

<!--&lt;!&ndash;<tr *ngIf="((data |searchfilter: 'user_name' : search.value).length === 0)&&data.length>0">&ndash;&gt;-->
<!--&lt;!&ndash;<td colspan="6">No Data Found</td>&ndash;&gt;-->
<!--&lt;!&ndash;</tr>&ndash;&gt;-->
<!--&lt;!&ndash;<tr *ngIf="data.length==0">&ndash;&gt;-->
<!--&lt;!&ndash;<td colspan="6"> {{tableMessage}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;</tr>&ndash;&gt;-->
<!--&lt;!&ndash;</tbody>&ndash;&gt;-->
<!--&lt;!&ndash;</table>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="text-center" *ngIf="data.length>0">&ndash;&gt;-->

<!--&lt;!&ndash;<div class="row" *ngIf="data.length>0;else noData">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12" class="text-center">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="pagination" *ngIf="length.length>0">&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="prvPage()" class="pointer">&laquo;</a>&ndash;&gt;-->
<!--&lt;!&ndash;<a *ngFor="let count of length;let i=index" (click)="page(i+1)" class="pointer"&ndash;&gt;-->
<!--&lt;!&ndash;[ngClass]="i+1==currentPage&&!isLastPage?'active':''">{{i+1}}</a>&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="nextPage()" class="pointer">&raquo;</a>&ndash;&gt;-->
<!--&lt;!&ndash;<a (click)="lastPage()" [ngClass]="isLastPage?'active':''" class="pointer">Last</a>&ndash;&gt;-->


<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="pagination" *ngIf="length.length==0">&ndash;&gt;-->
<!--&lt;!&ndash;<a class="disabled">&laquo;</a>&ndash;&gt;-->
<!--&lt;!&ndash;<a class="active">1</a>&ndash;&gt;-->
<!--&lt;!&ndash;<a class="disabled">&raquo;</a>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<ng-template #noData>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="col-md-12 text-center">&ndash;&gt;-->

<!--&lt;!&ndash;<span>{{message}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</ng-template>&ndash;&gt;-->


<!--&lt;!&ndash;&lt;!&ndash;<button class="btn btn-default" (click)="lastPage()" [disabled]="lastbuttonDisabled">Last</button>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<button class="btn btn-default" (click)="getPage()">Next</button>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->

<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="modal" id="locations" role="dialog">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="modal-dialog">&ndash;&gt;-->

<!--&lt;!&ndash;<div class="modal-content">&ndash;&gt;-->
<!--&lt;!&ndash;<div class="modal-header">&ndash;&gt;-->
<!--&lt;!&ndash;<button type="button" class="close" data-dismiss="modal">&times;</button>&ndash;&gt;-->
<!--&lt;!&ndash;<h4 class="modal-title">Location</h4>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="modal-body">&ndash;&gt;-->
<!--&lt;!&ndash;<div id="map" #map></div>&ndash;&gt;-->

<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;<div class="modal-footer">&ndash;&gt;-->
<!--&lt;!&ndash;<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->

<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
